import { useTranslation } from 'libs/i18n';
import { Typography } from 'libs/ui';

interface Props {
  index: number;
}

export const Header = ({ index }: Props) => {
  const { t } = useTranslation();
  return (
    <Typography variant="subtitle" variantMobile="bodyBold">
      {t(
        index === 0
          ? 'onboarding.companyLicense.licenseTitle'
          : 'onboarding.companyLicense.licenseOtherTitle'
      )}
    </Typography>
  );
};
